import i18n from "i18n";
import { useQuery } from "@tanstack/react-query";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import { defaultOnError } from "util/conditional/onError";
import PaginationURL from "util/PaginationURL";
import FiltersForQueryParams from "components/common/EntityFilters/FiltersForQueryParams";
export const fetchDataLakeRetrievals = async (searchParams) => {
  const url = PaginationURL(
    `/plugins/org.graylog.plugins.datalake/data_lake/retrievals`,
    searchParams.page,
    searchParams.pageSize,
    searchParams.query,
    {
      sort: searchParams.sort.attributeId,
      order: searchParams.sort.direction,
      filters: FiltersForQueryParams(searchParams.filters)
    }
  );
  return fetch("GET", qualifyUrl(url)).then(({ elements, ...rest }) => ({
    ...rest,
    list: elements
  }));
};
export const DataLakeRetrievalsQueryKey = "data-lake-retrievals";
export const keyFn = (searchParams) => [DataLakeRetrievalsQueryKey, searchParams];
const useDataLakeRetrievals = (searchParams, refetchInterval = 5e3) => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: keyFn(searchParams),
    queryFn: () => defaultOnError(
      fetchDataLakeRetrievals(searchParams),
      i18n.t("notifications.fetch_retrievals_failed", { ns: "enterprise_data_lake" }),
      i18n.t("notifications.fetch_retrievals_failed_title", { ns: "enterprise_data_lake" })
    ),
    notifyOnChangeProps: ["data", "error"],
    refetchInterval
  });
  return {
    data,
    refetch,
    isLoading,
    error
  };
};
export default useDataLakeRetrievals;
